"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
// prevent double-loading, which has the potential
// to prevent sharing state between services
var m;
try {
    m = angular.module('bcherny/ngimport');
}
catch (e) {
    m = angular.module('bcherny/ngimport', []);
}
m.config(['$provide', '$httpProvider', '$logProvider', function ($a, $b, $c) {
        exports.$provide = $a;
        exports.$httpProvider = $b;
        exports.$logProvider = $c;
    }]);
m.run(['$injector', function ($i) {
        exports.$anchorScroll = $i.get('$anchorScroll');
        exports.$cacheFactory = $i.get('$cacheFactory');
        exports.$compile = $i.get('$compile');
        exports.$controller = $i.get('$controller');
        exports.$document = $i.get('$document');
        exports.$exceptionHandler = $i.get('$exceptionHandler');
        exports.$filter = $i.get('$filter');
        exports.$http = $i.get('$http');
        exports.$httpBackend = $i.get('$httpBackend');
        exports.$httpParamSerializer = $i.get('$httpParamSerializer');
        exports.$httpParamSerializerJQLike = $i.get('$httpParamSerializerJQLike');
        exports.$injector = $i;
        exports.$interpolate = $i.get('$interpolate');
        exports.$interval = $i.get('$interval');
        exports.$locale = $i.get('$locale');
        exports.$location = $i.get('$location');
        exports.$log = $i.get('$log');
        exports.$parse = $i.get('$parse');
        exports.$q = $i.get('$q');
        exports.$rootElement = $i.get('$rootElement');
        exports.$rootScope = $i.get('$rootScope');
        exports.$sce = $i.get('$sce');
        exports.$sceDelegate = $i.get('$sceDelegate');
        exports.$templateCache = $i.get('$templateCache');
        exports.$templateRequest = $i.get('$templateRequest');
        exports.$timeout = $i.get('$timeout');
        exports.$window = $i.get('$window');
        exports.$xhrFactory = $i.get('$xhrFactory');
    }]);
//# sourceMappingURL=index.js.map